import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2'
import axios from "axios";
import QuestionContents from './UI/QuestionContents';
import { useParams } from "react-router-dom";
import { useAuth } from '../../../../../context/AuthContext';
import './matchcss.css';

const Match = (props) => {

    const { t, i18n } = useTranslation()
    const [msg, setMsg] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [question, setQuestion] = useState([]);
    const { user } = useAuth();
    const params = useParams();
    const [subjectName, setSubjectName] = useState("");
    const ATTEMPT_KEY = `choice_attempt_${props.questionNumber}`;
    const [slots, setSlots] = useState([]);


    const resetMatchFields = () => {
        setSlots(new Array(answers.length).fill(""));
        setAnswers(prev => prev.map(a => ({ ...a, used: false })));
        let correctAnswers = JSON.parse(props.data.detail);

        // yazma alanlarını boşalt
        for (let i = 0; i < correctAnswers.length; i++) {
            document.getElementById(i).innerText = " ";
        }

        // tüm butonları eski haline çevir
        for (let i = 0; i < correctAnswers.length; i++) {
            document.getElementById(correctAnswers[i].id + ".button").innerText =
                correctAnswers[i].service;
        }
    };

    const getSubject = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/GetSubject";
            await axios({
                method: 'GET',
                url: url,
                headers: headerss
            }).then(res => {
                if (res.data['success']) {
                    setSubjectName(
                        res.data['data']['subjects'][params['subjectid'] - 1]['subjectName'] +
                        " - " +
                        res.data['data']['subjects'][params['subjectid'] - 1]['subjectDesc']
                    )
                }
            });
        } catch (err) {
            console.log();
        }
    };

    const Request = async (userAnswer) => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = "https://api.heryerdeingilizce.com/api/user/Content/Answer";

            await axios({
                method: 'GET',
                url: url,
                params: {
                    questionId: props.questionNumber,
                    answer: userAnswer.toString()
                },
                headers: headerss
            }).then(res => {
                localStorage.removeItem(ATTEMPT_KEY);

                if (res.data['success']) {
                    let audio = new Audio("https://api.heryerdeingilizce.com/sound/d6350096-7457-46bc-bcaa-313a33970558.mp4");
                    audio.play();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    }).then(() => {
                        let newurl = Number(params['id']) + 1;
                        window.location.href = "/user/course/question/" + params['subjectid'] + "/" + newurl;
                    });
                }
                else {
                    if (res.data['alertType'] === "question") {
                        let audio = new Audio("https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4");
                        audio.play();
                        Swal.fire({
                            title: "Hatalı cevap",
                            text: "Doğru Cevap: " + res.data['message'],
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                    else {
                        let errorMsg = res['data']['message'];
                        let audio = new Audio("https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4");
                        audio.play();
                        Swal.fire({
                            title: "Hata",
                            text: errorMsg,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                }
            });
        }
        catch (err) {
            setMsg(err.message);
        }
    }

    // 🚀 SAYFA YENİLEME — deneme hakkını sıfırla
    const renewPage = async (e) => {
        e.preventDefault();
        sessionStorage.removeItem(`question_${props.questionNumber}_attempt`);
        window.location.reload();
    }

    // 🚀 MATCH SORU TÜRÜ 2 DENEME SİSTEMİ
    // const answerMatchHandle = async (e) => {
    //     e.preventDefault();

    //     // soru özel key
    //     const attemptKey = `question_${props.questionNumber}_attempt`;
    //     let attempt = Number(sessionStorage.getItem(attemptKey) || 0);

    //     // kullanıcı cevabı oluştur
    //     let correctAnswers = JSON.parse(props.data.detail);
    //     let userAnswer = "";

    //     for (let i = 0; i < correctAnswers.length; i++) {
    //         if (i === correctAnswers.length - 1) {
    //             userAnswer += document.getElementById(i).innerText;
    //         } else {
    //             userAnswer += document.getElementById(i).innerText + " ";
    //         }
    //     }
    //     alert(userAnswer.length);

    //     // backend doğru cevabı → props.answer
    //     const correctAnswer = props.answer;
    //     const isCorrect = userAnswer.trim() === correctAnswer.trim();
    //     // 1. DENEME
    //     if (attempt === 0) {
    //         if (userAnswer.trim() === correctAnswer) {
    //             Request(userAnswer.trim());
    //         } else {
    //             localStorage.setItem(ATTEMPT_KEY, "1");

    //             new Audio(
    //                 "https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4"
    //             ).play();

    //             Swal.fire({
    //                 title: "Tekrar Deneyiniz!",
    //                 text: props.data.notfyText,
    //                 icon: "warning",
    //             }).then(() => window.location.reload());
    //         }
    //         return;
    //     }

    //     // 2. DENEME → DİREKT BACKEND
    //     Request(userAnswer.trim());
    // };
    const answerMatchHandle = async (e) => {
        e.preventDefault();

        const correctAnswer = props.answer;
        const isSentence = correctAnswer.includes(" ");

        const userAnswer = isSentence ?
            slots.join(" ").trim()
            : slots.join("").trim();
        const correctAnswerr = props.data.answer;
        const attempt = parseInt(localStorage.getItem(ATTEMPT_KEY));

        //1. DENEME
        if (attempt === 0) {
            if (userAnswer === correctAnswerr) {
                Request(userAnswer);
            } else {
                localStorage.setItem(ATTEMPT_KEY, "1");

                new Audio(
                    "https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4"
                ).play();

                Swal.fire({
                    title: "Tekrar Deneyiniz!",
                    text: props.data.notfyText,
                    icon: "warning",
                }).then(() => window.location.reload());
            }
            return;
        }

        // 2. DENEME → DİREKT BACKEND
        Request(userAnswer);

    };
    const handleClick = (id) => {
        const clicked = answers.find(a => a.id === id);
        if (!clicked) return;

        setSlots(prev => {
            const copy = [...prev];
            const emptyIndex = copy.findIndex(x => x === "");
            if (emptyIndex === -1) return prev;

            copy[emptyIndex] = clicked.service;
            return copy;
        });

        setAnswers(prev =>
            prev.map(a =>
                a.id === id ? { ...a, used: true } : a
            )
        );
    };



    useEffect(() => {
        if (localStorage.getItem(ATTEMPT_KEY) === null) {
            localStorage.setItem(ATTEMPT_KEY, "0");
        }

        return () => {
            localStorage.removeItem(ATTEMPT_KEY);
        };
    }, [ATTEMPT_KEY]);
    useEffect(() => {
        console.log(props);

        getSubject();
        setQuestion(JSON.parse(props.data.contentStr));
        const detail = JSON.parse(props.data.detail);

        // span sayısı kadar boş slot
        setSlots(new Array(detail.length).fill(""));

        const parsed = JSON.parse(props.data.detail);

        setAnswers(parsed.map(a => ({
            ...a,
            used: false
        })));

    }, []);


    return (
        <div>
            <span style={{ color: "black" }}>
                <b><i>{subjectName}</i></b>
            </span>

            <br /><br />

            <div style={{ alignItems: "center", textAlign: "center" }}>
                <QuestionContents question={question} />
                <br />
                <b style={{ fontSize: "24px", fontFamily: 'calibri', color: "black" }}>
                    {question['text']}
                </b>
                <br /><br />
            </div>

            <div class="d-flex justify-content-center" style={{ fontSize: 20, textAlign: "center" }}>
                <form onSubmit={answerMatchHandle}>
                    <div className="row">
                        {slots.map((val, i) => (
                            <div className="col" key={i}>
                                <div className={`slot-box ${val ? "filled" : ""}`}>
                                    {val || "\u00A0"}
                                </div>
                            </div>
                        ))}
                    </div>



                    <br />

                    <div className="match-words">
                        {answers
                            .filter(dt => !dt.used)
                            .map((dt) => (
                                <button
                                    key={dt.id}
                                    className="match-word-btn"
                                    type="button"
                                    onClick={() => handleClick(dt.id)}
                                >
                                    {dt.service}
                                </button>
                            ))}
                    </div>



                    <br /><br />

                    <div class="d-flex justify-content-center">
                        <button className='renew-btn' onClick={renewPage}>Yeniden Oluştur</button>&nbsp;&nbsp;&nbsp;&nbsp;

                        {props.answered ? (
                            <b style={{ fontSize: "15px" }}> cevaplanmış <i>{props.realanswer}</i> </b>
                        ) : (
                            <div className='d-flex justify-content-center'>
                                <button style={{ left: "3%" }} type="submit" class="save-btn">{t("saveAndContinue")}</button>
                            </div>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Match;
